/* id对应价格 */
export const PriceImageData = {
  /* 99元 */
  1: {
    bgImage:
      'https://btw-common-data-oss.betterwestar.com/btw-admin/resource/5494d395c57d341c0981b5716a217b73_wh=1125_2898.webp',
    buttonImage:
      'https://btw-common-data.betterwestar.com/btw-admin/resource/1ca9a507fc7053fac2d2aca06527252d_wh=1125_249.webp'
  },
  /* 88元 */
  2: {
    bgImage:
      'https://btw-common-data-oss.betterwestar.com/btw-admin/resource/8703e1a8ed7eb95566da1402ebcb6d8f_wh=1125_2628.png',
    buttonImage:
      'https://btw-common-data-oss.betterwestar.com/btw-admin/resource/d2ec46f40c84ec47c83bf1da59cceeaa_wh=1125_231.png'
  },
  /* 129元 */
  3: {
    bgImage:
      'https://btw-common-data-oss.betterwestar.com/btw-admin/resource/cc012c0664ea8675284b8c3f1919aee2_wh=1125_2898.webp',
    buttonImage:
      'https://btw-common-data-oss.betterwestar.com/btw-admin/resource/5106678adf658746cd65e000044f2a6a_wh=1125_231.webp'
  },
  /* 109元 */
  4: {
    bgImage:
      'https://btw-common-data.betterwestar.com/btw-admin/resource/7a047c8d3dd091f5e0241ec6ea9f8cf2_wh=1125_3021.webp',
    buttonImage:
      'https://btw-common-data.betterwestar.com/btw-admin/resource/692b55d7bb8348a2aac06fa1b0cfa37e_wh=1125_264.webp'
  },
  /* 119元 */
  5: {
    bgImage:
      'https://btw-common-data.betterwestar.com/btw-admin/resource/5251cf0058fd361663db62e617ead886_wh=1125_3021.webp',
    buttonImage:
      'https://btw-common-data.betterwestar.com/btw-admin/resource/31e59eb161f36c440f45662365e7ff1c_wh=1125_264.webp'
  }
}
